var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.setLoading),expression:"setLoading"}],attrs:{"id":"app"}},[_c('Header',{staticClass:"header"}),_c('router-view'),(
      _vm.$route.path == '/' ||
      _vm.$route.path == '/about' ||
      _vm.$route.path == '/networkMarket' ||
      _vm.$route.path == '/server' ||
      _vm.$route.path == '/news' ||
      _vm.$route.path == '/listOfCases' ||
      _vm.$route.path == '/serverDetail'
    )?_c('Footer',{staticClass:"my_footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }